import { render, staticRenderFns } from "./designModule.vue?vue&type=template&id=50b370fb&scoped=true"
import script from "./designModule.vue?vue&type=script&lang=js"
export * from "./designModule.vue?vue&type=script&lang=js"
import style0 from "./designModule.vue?vue&type=style&index=0&id=50b370fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b370fb",
  null
  
)

export default component.exports